import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { FileService } from "../../services/file-service";
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { map } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
import {HTTPService} from "../../../../../src/app/service/http.service";
import {HTTPRequestBuilder} from "../../../../../src/app/model/http.request.model";
import {EnvironmentService} from "../../../../../src/app/service/environment.service";
import {HTTPMethod} from "../../../../../src/app/model/http-method.enum";
import { PagedQuery } from "../../../persistence/dto/paged-query.model";
import { MimeType } from "../../../model/mime-type.enum";
import { TypeSystem } from "../../../support/type-system.support";
import { BuyIntentionForUpdate } from "../../../persistence/dto/buy-intention-for-update";

@Injectable({
  providedIn: "root"
})
export class BuyIntentionService {

  constructor(private httpService: HTTPService,private http: HttpClient, private fileService: FileService, private httpUtils: HttpUtilsService, private environmentService: EnvironmentService) {}

  hostPath(): string {
    return this.environmentService.backendHost.href;
  }
  public basePath(): string {
      return "api/IntencionCompra";
  }

  private API_BUYINTENTION_URL = environment.API_URL + "api/IntencionCompra";
  
  getAllBuyIntention(){
    return this.http.get(this.API_BUYINTENTION_URL)
  }

  public findBuyIntention(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
        return this.httpService.send<QueryParamsModel, QueryResultsModel>(
            new HTTPRequestBuilder<QueryParamsModel>()
                .method(HTTPMethod.POST)
                .host(this.hostPath())
                .controllerPath(this.basePath())
                .relativePath(`find`)
                .payload(queryParams)
                .build()
        )
  }

  public downloadBuyIntention<T>(pagedQuery: PagedQuery<T>): Observable<Blob> {
		return this.httpService.send<PagedQuery<T>, Blob>(
			new HTTPRequestBuilder<PagedQuery<T>>()
				.method(HTTPMethod.POST)
				.controllerPath(this.basePath())
				.relativePath("exportBuyIntention")
				.payload(pagedQuery)
				.responseType("blob")
				.build())
			.pipe(
				map((response) => new Blob([response], { type: MimeType.MICROSOFT_EXCEL_XLSX })));
	}

  public updateBuyIntention(user: BuyIntentionForUpdate): Observable<typeof TypeSystem.EmptyObject> {
		return this.httpService.send<BuyIntentionForUpdate, null>(
			new HTTPRequestBuilder<BuyIntentionForUpdate>()
				.method(HTTPMethod.PUT)
				.controllerPath(this.basePath())
				.relativePath("edit")
				.payload(user)
				.build())
			.pipe(map(() => TypeSystem.EmptyObject));
	}

}
